import React, { ChangeEvent, Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import AppVo from '../blogData/AppVo';
import MainController from '../classes/MainController';
import { MainStorage } from '../classes/MainStorage';
import { DataCenter } from '../util/DataCenter';
import { MainUtil } from '../util/MainUtil';
interface MyProps { appVo: AppVo, callback: Function }
interface MyState { outputText: string, inputText: string, inputText2: string, waiting: boolean, hasError: boolean }
class GenScreen extends Component<MyProps, MyState>
{

    private ms: MainStorage = MainStorage.getInstance();
    private mc: MainController = MainController.getInstance();
    // private checkForEnter:Function;

    constructor(props: MyProps) {
        super(props);
        this.state = { outputText: "", inputText: "", inputText2: "", waiting: false, hasError: false };
        // this.checkForEnter=this.doCheckForEnter.bind(this);
    }
    doCheckForEnter(e: React.KeyboardEvent) {
        if (e.key === "Enter") {
            // this.doAction();
            if (this.state.inputText.length > this.props.appVo.minText) {
                this.sendText()
            }
        }
    }

    getAnother() {
        this.setState({ waiting: true });
        this.sendText();
    }
    copyText() {
        MainUtil.doCopy(this.state.outputText);
    }
    downloadText() {
        MainUtil.downloadText(this.state.outputText, this.state.inputText);
    }
    getOutputBox() {
        let disabled: boolean = this.state.hasError;
        return (<div className="form-group">
            <h4>Generated Text</h4>
            <textarea readOnly className="form-control gen-screen__text-area" id="exampleFormControlTextarea1" rows={3} defaultValue={this.state.outputText} />
            <Button disabled={disabled} className="btn btn-success gen-screen__button" onClick={this.copyText.bind(this)}>Copy</Button>
            <Button disabled={disabled} className="btn btn-primary gen-screen__button" onClick={this.downloadText.bind(this)}>Download</Button>
            <Button className="btn btn-warning gen-screen__button" onClick={this.getAnother.bind(this)}>Get Another</Button>
            <Button className="btn btn-danger gen-screen__button" onClick={() => { this.setState({ outputText: "" }) }}>Start Over</Button>
        </div>)
    }
    cleanText(text: string) {
        text = text.replaceAll("  "," ");
        text = text.replace(/\n/g, ' ');
       
        return text;
    }
    setText(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.value.length <= this.props.appVo.maxText) {
            //clean up text for double spaces and new lines
            let text: string = e.target.value;
            text = this.cleanText(text);
            this.setState({ inputText: text });
        }
        else {

            this.mc.showFlashMessage("Text is too long");
        }
    }
    setText2(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.value.length <= this.props.appVo.maxText) {
            let text: string = e.target.value;
            text = this.cleanText(text);
            this.setState({ inputText: text });
        }
        else {

            this.mc.showFlashMessage("Text too long");
        }

    }
    setText3(e: ChangeEvent<HTMLTextAreaElement>) {
        if (e.target.value.length <= this.props.appVo.maxText) {
            this.setState({ inputText: e.target.value });
        }
        else {
            this.mc.showFlashMessage("Text Too long");
        }
    }
    getForm1() {
        let labelArray: string[] = this.props.appVo.formData.split("|");
        let label1: string = labelArray[0] || "Input some words";
        let small1: string = labelArray[1] || "We will use these words to generate text";
        let placeholder1: string = labelArray[2] || "";
        let disabled: boolean = this.state.inputText.length < this.props.appVo.minText;

        return (<div>
            <h2>{this.props.appVo.title}</h2>
            <Row>
                <Col sm={12}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">{label1}</label>

                        <input type="text" onKeyDown={this.doCheckForEnter.bind(this)} className="form-control" id="exampleInputText1" aria-describedby="textHelp" value={this.state.inputText} placeholder={placeholder1} onChange={this.setText.bind(this)} />
                        <div>
                            <small id="textHelp" className="form-text text-muted">{small1}</small><span className='gen-screen__charcount'>{this.state.inputText.length}/{this.props.appVo.maxText}</span></div>
                    </div>
                    <Button className="btn btn-primary gen-screen__button" disabled={disabled} onClick={this.sendText.bind(this)}>{this.props.appVo.buttonText || "Write My Text"}</Button>

                </Col>
            </Row>
        </div>)
    }
    getForm2() {

        let labelArray: string[] = this.props.appVo.formData.split("|");
        let label1: string = labelArray[0] || "Input some words";
        let small1: string = labelArray[1] || "We will use these words to generate your text";
        let placeholder1: string = labelArray[2] || "";
        let label2: string = labelArray[3] || "Input some words";
        let small2: string = labelArray[4] || "We will use these words to generate your text";
        let placeholder2: string = labelArray[5] || "";
        let disabled: boolean = this.state.inputText.length < this.props.appVo.minText;

        return (<div>
            <h2>{this.props.appVo.title}</h2>
            <Row>
                <Col sm={12}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">{label1}</label>
                        <input type="text" onKeyDown={this.doCheckForEnter.bind(this)} className="form-control" id="exampleInputText1" aria-describedby="textHelp" placeholder={placeholder1} value={this.state.inputText} onChange={this.setText.bind(this)} />
                        <small id="textHelp" className="form-text text-muted">{small1}</small><span className='gen-screen__charcount'>{this.state.inputText.length}/{this.props.appVo.maxText}</span>
                    </div>
                    <div className="form-group">
                        <label htmlFor="detailInput">{label2}</label>
                        <input type="text" onKeyDown={this.doCheckForEnter.bind(this)} className="form-control" id="detailInput" value={this.state.inputText2} placeholder={placeholder2} onChange={this.setText2.bind(this)} />
                        <small id="textHelp" className="form-text text-muted">{small2}</small><span className='gen-screen__charcount'>{this.state.inputText2.length}/{this.props.appVo.maxText}</span>
                    </div>
                    <hr />
                    <Button disabled={disabled} className="gen-screen__button" onClick={this.sendText.bind(this)}>{this.props.appVo.buttonText || "Write My Text"}</Button>
                </Col>
            </Row>
        </div>);
    }
    getForm3() {
        let labelArray: string[] = this.props.appVo.formData.split("|");
        let label1: string = labelArray[0] || "Input some words";
        let small1: string = labelArray[1] || "We will use these words to generate your text";
        let placeholder1: string = labelArray[2] || "";
        let disabled: boolean = this.state.inputText.length < this.props.appVo.minText;

        return (<div><h2>{this.props.appVo.title}</h2>
            <Row>
                <Col sm={12}>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">{label1}</label>
                        <textarea onKeyDown={this.doCheckForEnter.bind(this)} rows={3} className="form-control" id="exampleInputText1" aria-describedby="textHelp" placeholder={placeholder1} value={this.state.inputText} onChange={this.setText3.bind(this)} />
                        <small id="textHelp" className="form-text text-muted">{small1}</small><span className='gen-screen__charcount'>{this.state.inputText.length}/{this.props.appVo.maxText}</span>
                    </div>
                    <hr />
                    <Button className="gen-screen__button" disabled={disabled} onClick={this.sendText.bind(this)}>{this.props.appVo.buttonText || "Write My Text"}</Button>
                </Col>
            </Row>
        </div>);
    }
    sendText() {
        this.setState({ waiting: true });
        DataCenter.sendText(this.ms.userCode, this.props.appVo.id, this.state.inputText, this.state.inputText2, this.textSent.bind(this));


    }
    textSent(data: any) {
        let response: string = data.response;
        if (response === null || response.length === 0) {
            response = "No response from server";
        }
        else {
            response = response.replace(/\\n/g, "");
            response = response.replace(/\\r/g, "");
            response = response.trim();
        }
        if (data.status === 1) {

            this.setState({ waiting: false, outputText: response, hasError: false });
            return;
        }
        this.setState({ waiting: false, outputText: "Error " + response, hasError: true });

    }
    getBox() {
        if (this.state.waiting === true) {
            return (<div className="gen-screen__waiting">
                <img src="./infin.gif" alt='waiting' />
                <h3>{this.props.appVo.waitingText || "Writing Your Text"}</h3>
            </div>)
        }
        if (this.state.outputText === "") {
            switch (this.props.appVo.formID) {
                case 0:
                    return this.getForm1();
                case 1:
                    return this.getForm2();
                case 2:
                    return this.getForm3();
            }
        }
        else {
            return this.getOutputBox();
        }
    }
    render() {
        //make one coulmn with 2 input text fields and a button
        //make one column with a text area

        return (<div>
            <div className='shade' onClick={() => { this.props.callback() }} ></div>
            <div className='gen-screen'>
                <Button variant='danger' className='close-button' onClick={() => { this.props.callback() }}>X</Button>
                {this.getBox()}
            </div>
        </div>)
    }
}
export default GenScreen;